import $ from 'jquery'

export class HelpModal {

  constructor (selector, selectorConf) {
    this.$modal = selector
    this.$modalConf = selectorConf
    this.$form = selector.find('form')
    this.$form.on('submit', (e) => {this.submitForm(e)})
    this.$formError = this.$form.find('.form-error')
    this.$submit = this.$form.find('button')
    this.$modal.modal('show')  

  }

  submitForm(e) {
    e.preventDefault()
    this.$submit.prop('disabled', true)
    this.$form.find('.text-danger').remove()
    $.ajax({
        url: this.$form.attr('action'),
        method: 'POST',
        data: this.$form.serialize(),
        dataType: "json"
    }).then((response) => {
        this.onSuccess(response)
    }).catch((err) => {
        this.onError(err)
    })
    return false
  }

  onSuccess(response) {
    this.$modal.modal('hide')
    this.$modalConf.modal('show')
  }

  onError(err) {
    this.$submit.prop('disabled', false)
    var f_info = undefined;
    for (var f_name in err.responseJSON) {
      f_info = err.responseJSON[f_name]
      var err_txt = f_info
      var label = f_name
      if(err_txt !== undefined) {
        this.$form.find('#id_' + f_name).parent().append(
          '<div class="text-danger">' + err_txt + '</div>'
        )
      }
    }
  }

}




// WEBPACK FOOTER //
// ./skippair/static/js/components/help-modal.js